"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyOfferingTimes = exports.getAuthorization = exports.prepareModifyOfferingTimes = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
/**
 * @hidden
 */
function validateInput(sale, newStart, start, newEnd, end, timing) {
    if ([types_1.OfferingSaleStatus.Closed, types_1.OfferingSaleStatus.ClosedEarly].includes(sale)) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'The Offering is already closed',
        });
    }
    const areSameTimes = (!newStart || start === newStart) && (newEnd === undefined || end === newEnd);
    if (areSameTimes) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.NoDataChange,
            message: 'Nothing to modify',
        });
    }
    const now = new Date();
    if (timing === types_1.OfferingTimingStatus.Expired) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'The Offering has already ended',
        });
    }
    if (timing !== types_1.OfferingTimingStatus.NotStarted && newStart) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'Cannot modify the start time of an Offering that already started',
        });
    }
    const datesAreInThePast = (newStart && now > newStart) || (newEnd && now > newEnd);
    if (datesAreInThePast) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.ValidationError,
            message: 'New dates are in the past',
        });
    }
}
/**
 * @hidden
 */
function prepareModifyOfferingTimes(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx: { sto: txSto }, }, }, context, } = this;
        const { asset, id, start: newStart, end: newEnd } = args;
        const offering = new internal_1.Offering({ id, assetId: asset.id }, context);
        const { status: { sale, timing }, end, start, } = yield offering.details();
        validateInput(sale, newStart, start, newEnd, end, timing);
        const rawAssetId = (0, conversion_1.assetToMeshAssetId)(asset, context);
        const rawId = (0, conversion_1.bigNumberToU64)(id, context);
        const rawStart = newStart ? (0, conversion_1.dateToMoment)(newStart, context) : (0, conversion_1.dateToMoment)(start, context);
        let rawEnd;
        if (newEnd === null) {
            rawEnd = null;
        }
        else if (!newEnd) {
            rawEnd = end && (0, conversion_1.dateToMoment)(end, context);
        }
        else {
            rawEnd = (0, conversion_1.dateToMoment)(newEnd, context);
        }
        return {
            transaction: txSto.modifyFundraiserWindow,
            args: [rawAssetId, rawId, rawStart, rawEnd],
            resolver: undefined,
        };
    });
}
exports.prepareModifyOfferingTimes = prepareModifyOfferingTimes;
/**
 * @hidden
 */
function getAuthorization({ asset }) {
    return {
        permissions: {
            transactions: [types_1.TxTags.sto.ModifyFundraiserWindow],
            assets: [asset],
            portfolios: [],
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
const modifyOfferingTimes = () => new internal_1.Procedure(prepareModifyOfferingTimes, getAuthorization);
exports.modifyOfferingTimes = modifyOfferingTimes;
//# sourceMappingURL=modifyOfferingTimes.js.map